import FolderOutlinedIcon from '@mui/icons-material/FolderOutlined';
import React from 'react';

export const FoldersIcon = ({
	bgColor = 'rgba(251, 206, 58, 0.35)',
	width = '24px',
	height = '24px',
	...props
}) => {
	return (
		<FolderOutlinedIcon
			{...props}
			sx={{
				backgroundColor: bgColor,
				width,
				height,
				fontSize: width,
				boxSizing: 'border-box',
				borderRadius: 2,
				p: '0.15em',
				color: '#fff',
			}}
		/>
	);
};
